import React, { useEffect, useRef } from "react";

import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { Typography } from "@progress/kendo-react-common";
// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";

import moment from "moment";
import { Button } from "@progress/kendo-react-buttons";
// import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import { IoMdPrint } from "react-icons/io";
import {
  checkAcessRights,
  formatToIndianCurrencyWithoutSymbol,
  formatWeight,
} from "../../../_helper/helper";
import { PRINT_ACCESS } from "../../../_contstants/common";
import { useParams } from "react-router-dom";
import { LoadingPanel } from "../../../components/layout/Loading";
import { getKarigarPhineLedgerReport } from "../services/reports.services";
import { sumBy } from "lodash";

const KarigarPhineLedgerReportView: React.FC = () => {
  const dispatch = useAppDispatch();

  const params = useParams();
  const fromdate = params.fromdate;
  const todate = params.todate;
  const karigar_id = params.karigar_id;
  // const tablecontentRef = useRef<any>(null);
  const gridRef = useRef<any>(null);
  const loading = useAppSelector((state) => state.reports.loading);
  const KarigarPhineLedgerReportList = useAppSelector(
    (state) => state.reports.KarigarPhineLedgerReportList
  );
  // const isExcelExportAccess = checkAcessRights(
  //   "/karigar-phine-ledger-report",
  //   EXCEL_EXPORT_ACCESS
  // );
  const isPrintAccess = checkAcessRights(
    "/karigar-phine-ledger-report",
    PRINT_ACCESS
  );

  const fetchKarigarPhineLedgerReport = async (payload: any) => {
    await dispatch(getKarigarPhineLedgerReport(payload));
  };

  useEffect(() => {
    if (fromdate && todate && karigar_id) {
      const payload = {
        karigar_id: karigar_id,
        from_date: fromdate,
        to_date: todate,
      };
      fetchKarigarPhineLedgerReport(payload);
    }
  }, []);

  const printTable = () => {
    window.print();
    return;
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem>
          <GridLayoutItem>
            <div
              className="printbuttons"
              style={{
                textAlign: "center",
                padding: "20px",
                display: "block",
              }}
            >
              {/* {isExcelExportAccess && (
                <Button
                  type="button"
                  fillMode={"solid"}
                  themeColor={"primary"}
                  onClick={handleExportExcel}
                  style={{
                    marginRight: "10px",
                    padding: "5px 10px",
                    border: "none",
                    backgroundColor: "#3b823b",
                  }}
                >
                  <PiMicrosoftExcelLogoFill style={{ fontSize: "20px" }} />{" "}
                  Excel Export
                </Button>
              )} */}
              {isPrintAccess && (
                <Button
                  type="button"
                  style={{
                    marginRight: "10px",
                    padding: "5px 10px",
                    border: "none",
                  }}
                  fillMode={"solid"}
                  themeColor={"primary"}
                  onClick={printTable}
                >
                  <IoMdPrint style={{ fontSize: "20px" }} /> Print Report
                </Button>
              )}
            </div>
          </GridLayoutItem>
          <GridLayoutItem>
            <Typography.h5
              style={{
                marginBottom: 0,
                textAlign: "center",
              }}
            >
              Karigar Phine (gm) Ledger Report
            </Typography.h5>
            <Typography.h6
              style={{
                marginBottom: 15,
                textAlign: "center",
              }}
            >
              (
              {fromdate
                ? moment(fromdate, "YYYY-MM-DD").format("DD/MM/YYYY")
                : ""}
              {" to "}
              {todate ? moment(todate, "YYYY-MM-DD").format("DD/MM/YYYY") : ""})
            </Typography.h6>
          </GridLayoutItem>
          {/* REPORT LIST */}
          {KarigarPhineLedgerReportList &&
          KarigarPhineLedgerReportList.length > 0 ? (
            <div className="karigar-phine-ledger">
              <div className="table-container">
                <table className="ledger-table">
                  <thead>
                    <tr>
                      <th className="col-date">Date</th>
                      <th className="col-desc">Description</th>
                      <th className="col-issue-no">Issue No</th>
                      <th className="col-item">Item Name</th>
                      <th className="col-issue">Phine (gm) Issue</th>
                      <th className="col-receipt">Phine (gm) Receipt</th>
                      <th className="col-balance">Balance</th>
                    </tr>
                  </thead>
                  <tbody>
                    {KarigarPhineLedgerReportList.map((data, index) => (
                      <tr
                        key={index}
                        className={index % 2 === 0 ? "even-row" : "odd-row"}
                      >
                        <td className="cell-date">{data?.Date}</td>
                        <td
                          className="cell-desc"
                          style={{
                            fontWeight: index === 0 ? "bold" : "normal",
                          }}
                        >
                          {index === 0 ? `Opening Balance` : data?.karigar_name}
                        </td>
                        <td className="cell-issue-no">{data?.issue_no}</td>
                        <td className="cell-item">{data?.item_name}</td>
                        <td
                          className="cell-issue"
                          style={{
                            fontWeight: index === 0 ? "bold" : "normal",
                          }}
                        >
                          {formatWeight(data?.phine_issue)}
                        </td>
                        <td
                          className="cell-receipt"
                          style={{
                            fontWeight: index === 0 ? "bold" : "normal",
                          }}
                        >
                          {formatWeight(data?.phine_receipt)}
                        </td>
                        <td
                          className="cell-balance"
                          style={{
                            fontWeight: index === 0 ? "bold" : "normal",
                          }}
                        >
                          {formatToIndianCurrencyWithoutSymbol(
                            data?.closing_balance || 0
                          )}{" "}
                          {data.creditdebittype === "Credit" ? "Cr" : "Dr"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr className="totals-row">
                      <td colSpan={4} className="totals-label">
                        TOTALS
                      </td>
                      <td className="total-issue text-end">
                        {formatWeight(
                          sumBy(
                            KarigarPhineLedgerReportList,
                            "phine_issue"
                          )
                        )}
                      </td>
                      <td className="total-receipt text-end">
                        {formatWeight(
                          sumBy(
                            KarigarPhineLedgerReportList,
                            "phine_receipt"
                          )
                        )}
                      </td>
                      <td className="total-balance text-end">
                        {formatToIndianCurrencyWithoutSymbol(
                          KarigarPhineLedgerReportList?.at(-1)
                            ?.closing_balance ?? 0
                        )}{" "}
                        {KarigarPhineLedgerReportList?.at(-1)
                          ?.creditdebittype === "Credit"
                          ? "Cr"
                          : "Dr"}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          ) : null}
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

export default KarigarPhineLedgerReportView;
